/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Fiyat_KurallariInputs */

const tr_faq_q_fiyat_kurallari = /** @type {(inputs: Faq_Q_Fiyat_KurallariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat kuralları nasıl ayarlanır?`)
};

const en_faq_q_fiyat_kurallari = /** @type {(inputs: Faq_Q_Fiyat_KurallariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I set up pricing rules?`)
};

const de_faq_q_fiyat_kurallari = /** @type {(inputs: Faq_Q_Fiyat_KurallariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie richte ich Preisregeln ein?`)
};

const ru_faq_q_fiyat_kurallari = /** @type {(inputs: Faq_Q_Fiyat_KurallariInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как настроить ценовые правила?`)
};

/**
* | output |
* | --- |
* | "How do I set up pricing rules?" |
*
* @param {Faq_Q_Fiyat_KurallariInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_fiyat_kurallari = /** @type {((inputs?: Faq_Q_Fiyat_KurallariInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Fiyat_KurallariInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_fiyat_kurallari(inputs)
	if (locale === "de") return de_faq_q_fiyat_kurallari(inputs)
	if (locale === "ru") return ru_faq_q_fiyat_kurallari(inputs)
	return tr_faq_q_fiyat_kurallari(inputs)
});